jQuery(function ($) {
	const base = "gc-navbar";

	$(`.${base}__burger`).on("click", function () {
		$(`.${base}`).toggleClass(`${base}--active`);
	});

	$(`.${base}__expand`).on("click", function () {
		$(this).toggleClass(`${base}__expand--active`);
		$(this).next().toggleClass(`${base}__toggle-menu--active`);
	});
});
